import classNames from "classnames"

import { ChevronRightIcon } from "@heroicons/react/16/solid"

export default function BreadcrumbNav({ crumbs }) {
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {crumbs.map((page, index) => {
          const classes = classNames("font-medium text-gray-500", {
            "hover:text-feature-6 text-primary-4": page.href,
          })

          return (
            <li key={page.name}>
              <div className="flex items-center">
                {index > 0 && (
                  <ChevronRightIcon
                    className="mr-1 size-4 shrink-0 text-gray-400"
                    aria-hidden="true"
                  />
                )}
                {page.href && (
                  <a
                    href={page.href}
                    data-turbo-frame="_top"
                    aria-current={page.current ? "page" : undefined}
                  >
                    <div className={classes}>{page.name}</div>
                  </a>
                )}
                {!page.href && <div className={classes}>{page.name}</div>}
              </div>
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
